export default __webpack_public_path__ + "public/assets/images/20c209ba20b2434c4a9ac5be8cedd14f.png";